import { render, staticRenderFns } from "./RatingProfessorStat.vue?vue&type=template&id=38cee30c"
import script from "./RatingProfessorStat.vue?vue&type=script&lang=js"
export * from "./RatingProfessorStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports